import {Box} from 'src/design/atoms/Box';
import {Center} from 'src/design/atoms/Center';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {Title} from 'src/design/atoms/Title';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import {Button} from 'src/design/atoms/Button';
import {routeRegistry} from 'src/pages/RouteRegistry';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const documentTitle = '404 Page Not Found';

const PageNotFoundPage = () => {
  useSetDocumentTitle(documentTitle);

  return (
    <Center>
      <Stack mt="md" gap="md">
        <Title>Page Not Found</Title>
        <Text>
          The page you are looking for does not exist. Please check the URL and
          try again.
        </Text>
        <Box>
          <Button
            aria-label="backToHomeBtnUI"
            onClick={() => window.location.assign(PathUtility.Dashboard())}>
            Back to Home
          </Button>
        </Box>
      </Stack>
    </Center>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.NotFound(),
  element: <PageNotFoundPage />,
  isPrivate: false,
});

// Register catch-all route
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: '*',
  element: <PageNotFoundPage />,
  isPrivate: false,
});

export default PageNotFoundPage;
